import { render, staticRenderFns } from "./AssignCourse.vue?vue&type=template&id=3b76546e&scoped=true&"
import script from "./AssignCourse.vue?vue&type=script&lang=js&"
export * from "./AssignCourse.vue?vue&type=script&lang=js&"
import style0 from "./AssignCourse.vue?vue&type=style&index=0&id=3b76546e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b76546e",
  null
  
)

export default component.exports